import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../constants';
import { ApiResponse, PaginatedResponse, User } from '../types';

export interface ListUsersParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const tenantService = {
  async list(params: ListUsersParams = {}): Promise<PaginatedResponse<User>> {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    return apiClient.get<PaginatedResponse<User>>(`${API_ENDPOINTS.TENANT.LIST}?${query.toString()}`, {
      authenticate: true,
    });
  },
  async get(id: string): Promise<User> {
    return apiClient.get<User>(API_ENDPOINTS.TENANT.DETAIL(id), {
      authenticate: true,
    });
  },
  async create(data: {
    name: string;
    slug: string;
    domain?: string;
    description?: string;
    plan?: string;
    maxUsers?: number;
    isWhitelabeled?: boolean;
    /** The tenant's first admin, created together with the tenant. */
    admin: { email: string; password: string; firstName?: string; lastName?: string };
  }): Promise<any> {
    return apiClient.post<any>(API_ENDPOINTS.TENANT.LIST, data, { authenticate: true });
  },

  async update(id: string, data: any): Promise<User> {
    return apiClient.put<User>(API_ENDPOINTS.TENANT.UPDATE(id), data, {
      authenticate: true,
    });
  },
};


